
import { Component, Vue } from 'vue-property-decorator'
import { NavBar, BreadCrumb } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

@Component({
  components: {
    NavBar,
    BreadCrumb
  }
})
export default class TaskReviewTranscriptView extends Vue {
  data () {
    return this.getResetData()
  }

  getResetData () {
    return {
      isLoading: false,
      remainTime: '',
      disabled: true,
      isPlaying: false,
      filePath: null,
      maxDuration: 120000,
      currentTimeMillis: 0,
      taskId: null,
      audioUrl: null,
      audioElement: null,
      transcripts: [],
      textTranscript: '',
      editIdx: null,
      selectIdx: null,
      settingStart: false,
      settingStop: false,
      isValid: false,
      isFirstTimeLoad: false,
      firstTimePlaying: false,
      autoPlayAllowed: false
    }
  }

  mounted () {
    this.taskId = this.$route.params.taskId
    this.detectAutoPlayPolicy()
    this.getTaskData()
  }

  detectAutoPlayPolicy () {
    if (typeof navigator.getAutoplayPolicy === 'function') {
      if (navigator.getAutoplayPolicy('mediaelement') === 'allowed') {
        this.autoPlayAllowed = true
      } else if (navigator.getAutoplayPolicy('mediaelement') === 'allowed-muted') {
        this.autoPlayAllowed = true
      } else if (navigator.getAutoplayPolicy('mediaelement') === 'disallowed') {
        this.autoPlayAllowed = false
      }
    } else {
      this.autoPlayAllowed = false
    }
  }

  updatePlayerTime () {
    // this.currentTimeMillis = Math.floor(this.audioElement.currentTime) * 1000
    this.currentTimeMillis = Math.floor(this.audioElement.currentTime * 1000)
    var idx = this.transcripts.findIndex(e => e.start * 1000 <= this.currentTimeMillis && e.stop * 1000 >= this.currentTimeMillis)
    if (idx > -1) {
      this.selectChip(idx)
    }
  }

  updatePlayerDuration () {
    // this.maxDuration = Math.floor(this.audioElement.duration) * 1000
    this.maxDuration = Math.floor(this.audioElement.duration * 1000)
  }

  validateTranscripts () {
    // var currentIdx
    this.transcripts.sort((a, b) => { return a.start > b.start })
    // this.selectChip(idx)
    var els = Array.from(document.getElementsByClassName('invalid'))
    for (var i = 0; i < els.length; i++) {
      els[i].classList.remove('invalid')
    }
    this.isValid = true
    for (i = 0; i < this.transcripts.length; i++) {
      if (i < this.transcripts.length - 1 && this.transcripts[i].stop > this.transcripts[i + 1].start) {
        var id = `chip-${i}`
        this.$refs[id][0].classList.add('invalid')
        id = `chip-${i + 1}`
        this.$refs[id][0].classList.add('invalid')
        this.isValid = false
      }
      if (this.transcripts[i].start >= this.transcripts[i].stop) {
        id = `chip-${i}`
        this.$refs[id][0].classList.add('invalid')
        this.isValid = false
      }
      if (this.transcripts[i].stop * 1000 >= this.maxDuration) {
        id = `chip-${i}`
        this.$refs[id][0].classList.add('invalid')
        this.isValid = false
      }
    }
  }

  formatSecs (val) {
    /* var d = Math.abs(val) / 60000
    var mins = Math.floor(d)
    var secs = Math.floor((d - mins) * 60)
    var timerMins = mins === 0 ? '' : mins < 10 ? `0${mins}` : mins
    var timerSecs = secs < 10 ? `0${secs}` : secs
    return `${timerMins}${timerMins === '' ? '' : ':'}${timerSecs}` */
    return `${val}`
  }

  pause () {
    if (this.audioElement) {
      this.isPlaying = false
      this.audioElement.pause()
      if (this.isFirstTimeLoad) {
        this.validateTranscripts()
        this.isFirstTimeLoad = false
        this.firstTimePlaying = false
      }
    }
  }

  play () {
    if (this.isFirstTimeLoad) {
      this.firstTimePlaying = true
    }
    this.isPlaying = true
    this.audioElement.play()
  }

  playEnded () {
    this.pause()
  }

  selectChip (idx) {
    if (!this.transcripts[idx]) {
      return
    }
    this.selectIdx = idx
    var els = Array.from(document.getElementsByClassName('selected'))
    for (var i = 0; i < els.length; i++) {
      els[i].classList.remove('selected')
    }
    var id = `chip-${idx}`
    this.$refs[id][0].classList.add('selected')
    this.$refs[id][0].scrollIntoView()
  }

  setCurrentTime (idx) {
    // https://www.stellarinfo.com/article/convert-webm-to-mp3-file.php
    this.currentTimeMillis = this.transcripts[idx].start * 1000
    this.audioElement.currentTime = this.currentTimeMillis / 1000
  }

  deleteChip (event, idx) {
    event.stopPropagation()
    this.transcripts.splice(idx, 1)
    this.removeEditIdx(idx)
    this.selectChip(idx)
  }

  removeEditIdx (idx) {
    this.editIdx = null
    var els = Array.from(document.getElementsByClassName('edit'))
    for (var i = 0; i < els.length; i++) {
      els[i].classList.remove('edit')
    }
  }

  editChip (event, idx) {
    if (!this.transcripts[idx]) {
      return
    }
    this.removeEditIdx(idx)
    this.selectChip(idx)
    this.editIdx = idx
    var id = `chip-${idx}`
    this.$refs[id][0].classList.add('edit')
  }

  addChip (event, idx, right) {
    var start = idx === 0 ? 0 : this.transcripts[idx - 1].stop
    var obj = {
      start,
      stop: idx === this.transcripts.length - 1 ? start : this.transcripts[idx + 1].start,
      word: 'placeholder'
    }
    this.transcripts.splice(idx, 0, obj)
    setTimeout(() => { this.editChip(event, idx) }, 100)
  }

  onEnter (event, idx) {
    if (this.transcripts[idx].word !== event.target.value) {
      this.transcripts[idx].word = event.target.value
    }
    this.removeEditIdx(idx)
  }

  inputFocused (evt) {
    evt.stopPropagation()
  }

  setStartChip (event, idx) {
    event.stopPropagation()
    this.transcripts[idx].start = event.target.value / 1000
    // this.settingStart = false
    this.validateTranscripts()
  }

  setStopChip (event, idx) {
    event.stopPropagation()
    this.transcripts[idx].stop = event.target.value / 1000
    // this.settingStop = false
    this.validateTranscripts()
  }

  async save () {
    this.transcripts = this.getTranscriptFromText(this.textTranscript)
    await this.updateOnServer(false)
  }

  async finish () {
    this.transcripts = this.getTranscriptFromText(this.textTranscript)
    await this.updateOnServer(true)
  }

  displayModalFinish () {
    this.$buefy.dialog.confirm({
      title: 'Are you sure?',
      message: 'By confirming, you won`t be able to change it back.',
      onConfirm: () => {
        this.finish()
      },
      canCancel: true
    })
  }

  fillRemainTime (due) {
    if (due) {
      var now = new Date()
      var days = (due.valueOf() - now.valueOf()) / (1000 * 3600 * 24)
      if (days <= 0) {
        this.remainTime = 'Expired'
      } else {
        var hours = (days - Math.floor(days)) * 24
        var mins = 0
        if ((hours - Math.floor(hours)) > 0) {
          mins = (hours - Math.floor(hours)) * 60
        }
        var daysString = days < 10 ? days < 1 ? '' : `0${Math.floor(days)} Days and ` : `${Math.floor(days)} Days and `
        var hoursString = hours < 10 ? `0${Math.floor(hours)}` : Math.floor(hours)
        var minsString = mins < 10 ? `0${Math.floor(mins)}` : Math.floor(mins)

        this.remainTime = `${daysString}${hoursString}:${minsString} h `
      }
    } else {
      this.remainTime = ''
    }
  }

  getTextFromTranscript (transcript) {
    var text = ''
    for (var i = 0; i < transcript.length; i++) {
      text += transcript[i].word + ' '
    }
    return text.substring(0, text.length - 1)
  }

  getTranscriptFromText (text) {
    var transcs = text.split(' ')
    transcs = transcs.filter(e => e !== '')
    return transcs.map(e => {
      return {
        start: 0,
        word: e,
        stop: 0
      }
    })
  }

  async getTaskData () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getReviewTranscriptTaskData${this.taskId ? '/' + this.taskId : ''}`))
      this.taskData = JSON.parse(resp.data)
      this.transcripts = resp.transcripts
      this.textTranscript = this.getTextFromTranscript(this.transcripts)
      this.disabled = resp.completed || new Date(resp.due) <= new Date()
      this.fillRemainTime(new Date(resp.due))
      if (!this.taskId) {
        this.taskId = resp.id
      }
      this.filePath = resp.filePath
      if (this.audioElement) {
        this.audioElement.removeEventListener('ended', this.pause)
        this.audioElement.removeEventListener('timeupdate', this.updatePlayerTime)
        this.audioElement.removeEventListener('durationchange', this.updatePlayerDuration)
      }
      if (this.filePath) {
        this.audioUrl = encodeURI(`${process.env.VUE_APP_SERVERURL}/media/${this.filePath}?cb=${new Date().getTime()}`)
        const blob = await FetchWrapper.getBlob(this.audioUrl)
        const blobUrl = URL.createObjectURL(blob)
        this.audioElement = new Audio(blobUrl)
        this.audioElement.addEventListener('ended', this.pause)
        this.audioElement.addEventListener('timeupdate', this.updatePlayerTime)
        this.audioElement.addEventListener('durationchange', this.updatePlayerDuration)
        this.audioElement.load()
        if (this.autoPlayAllowed) {
          this.play()
        }
      } else {
        this.audioUrl = null
        this.audioElement = null
        this.maxDuration = 120000
      }
      this.isLoading = false
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get task data. ${e}`,
        canCancel: false
      })
    }
  }

  async updateOnServer (completed) {
    this.isLoading = true
    const resp = await FetchWrapper.post(
      `${process.env.VUE_APP_SERVERURL}/updateReviewTranscriptTaskData`,
      {
        data: { transcripts: this.transcripts },
        id: Number(this.taskId),
        completed
      }
    )
    this.isLoading = false
    if (resp.error || resp.statusCode) {
      this.$buefy.dialog.confirm({
        title: 'Error while saving.',
        message: resp.error,
        canCancel: false
      })
    } else {
      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Task saved Successfully',
        onConfirm: () => {
          if (completed) {
            window.location.href = '/home/tasks'
          } else {
            window.location.href = `/home/reviewTranscript/${this.taskId}`
          }
        },
        canCancel: false
      })
    }
  }
}
